import {makeStyles} from "@material-ui/core";

export const useSoglieFilterStyles = makeStyles((theme) => ({
    typographyRadioButtons: {
        margin: "0.3em 1em",
    },
    filterBtn: {
        [theme.breakpoints.down('xs')]: {
            width: "100%",
            margin: "1em 0em"
        },
        [theme.breakpoints.up('sm')]: {
            minWidth: "8em",
            marginRight: "2em",
            marginBottom: "2em"
        }
    }
}));